/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2, breakpoints } from '@coursera/cds-core';

import LazyImgix from 'bundles/page/components/shared/LazyImgix';

const styles = {
  testimonialAuthorContainer: css`
    width: 60%;
    margin: auto;
    display: flex;
    margin-top: 15px;
    flex-direction: row;
    ${breakpoints.down('xs')} {
      width: 100%;
    }

    html[dir='rtl'] & {
      flex-direction: row-reverse;
    }
  `,
  headshot: css`
    margin-right: 25px;

    img {
      width: 90px;
      height: 90px;
      border-radius: 50%;
    }
  `,

  authorText: css`
    text-align: left;
  `,
};

type Props = {
  authorName?: string | null;
  authorTitle?: string | null;
  imageUrl?: string | null;
};

const TestimonialAuthor = ({ authorName, authorTitle, imageUrl }: Props) => {
  if (!authorName || !imageUrl) {
    return null;
  }

  return (
    <div css={styles.testimonialAuthorContainer}>
      <div css={styles.headshot}>
        <LazyImgix src={imageUrl} alt={authorName || ''} maxHeight={90} maxWidth={90} />
      </div>
      <div css={styles.authorText}>
        <Typography2 variant="subtitleMedium" component="p">
          {authorName}
        </Typography2>
        <Typography2 component="p" variant="bodyPrimary" color="supportText">
          {authorTitle}
        </Typography2>
      </div>
    </div>
  );
};

export default TestimonialAuthor;
